import _shuffle from 'lodash.shuffle';
import _uniqBy from 'lodash.uniqby';
export const sort = (comparator) => (array) => {
    const arrayCopy = [...array];
    arrayCopy.sort(comparator);
    return arrayCopy;
};
export const shuffle = _shuffle;
export const uniqueBy = _uniqBy;
//# sourceMappingURL=arrays.js.map